package com.snakesworld.game.domain

/**
 * Pixel widths for the Hall of Champions header and rows.
 *
 * Rank, score, and kills stay exactly as wide as their labels (or a sample
 * value, whichever is larger) so those headers never wrap. Nickname takes the
 * remaining width and must be at least as wide as its own header.
 */
data class LeaderboardColumnPlan(
    val rankPx: Int,
    val nicknamePx: Int,
    val scorePx: Int,
    val killsPx: Int,
    val fitsWithoutClippingHeaders: Boolean,
)

fun planLeaderboardColumns(
    availablePx: Int,
    rankPx: Int,
    nicknameHeaderPx: Int,
    scorePx: Int,
    killsPx: Int,
    gapPx: Int,
): LeaderboardColumnPlan {
    val fixed = rankPx + scorePx + killsPx + gapPx * 3
    val remaining = availablePx - fixed
    val fits = remaining >= nicknameHeaderPx && nicknameHeaderPx >= 0
    return LeaderboardColumnPlan(
        rankPx = rankPx,
        nicknamePx = if (fits) remaining else nicknameHeaderPx.coerceAtLeast(0),
        scorePx = scorePx,
        killsPx = killsPx,
        fitsWithoutClippingHeaders = fits,
    )
}
